import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'
import { createPinia } from 'pinia'
import { initMonitoring } from './utils/monitoring'
import { registerServiceWorker } from './utils/registerServiceWorker'

const app = createApp(App)
const pinia = createPinia()

// Pinia before router so stores are available in navigation guards and on first paint.
app.use(pinia)
app.use(router)

// Install error monitoring (and Sentry, if VITE_SENTRY_DSN is set) before mount
// so the global handlers are active for any startup errors. Mount regardless of
// whether monitoring init succeeds.
initMonitoring(app, router).finally(() => {
  app.mount('#app')
})

registerServiceWorker()
